import { Link } from "react-router";
import "./ErrorPage.css";

export default function ErrorPage({
  errorCode,
  errorStatus,
  resetErrorBoundary,
}: {
  errorCode: number;
  errorStatus: string;
  resetErrorBoundary?: () => void;
}) {
  return (
    <div className="error-page">
      <div className="error-page__content">
        <div className="error-page__summary">
          <div className="error-page__title">
            <span>{errorCode}</span>
            <h1>{errorStatus}</h1>
            <hr />
          </div>
        </div>
        <div className="error-page__description">
          <div className="error-page__text">
            {resetErrorBoundary ? (
              <span>
                OOPS! Something went wrong.{" "}
                <button className="link" onClick={() => resetErrorBoundary()}>
                  Try again
                </button>{" "}
                or go to the{" "}
                <Link to="/" className="link">
                  home page.
                </Link>
              </span>
            ) : (
              <span>
                OOPS! Something went wrong. Try going back or go to the{" "}
                <Link to="/" className="link">
                  {" "}
                  home page.{" "}
                </Link>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
